<template>
  <div class="form-group">
    <div class="item-name">
      <label class="item">氏名</label><label class="required">必須</label>
      <!-- <div v-if="$v.familyName.$dirty">
        <div class="error-text margin-10" v-if="!$v.familyName.required">
          名前を入力してください。
        </div>
      </div> -->
    </div>
    <!-- :class="status($v.familyName)"
    v-model="$v.familyName.$model" -->
    <input class="form-control margin-right-10" type="text" placeholder="姓" @change="changeFamilyName"/>
    <input class="form-control" type="text" placeholder="名" @change="changeFirstName"/>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  data () {
    return {
      familyName: "",
      firstName: ""
    }
  },
  // validations: {
  //   familyName: {
  //     required
  //   },
  //   firstName: {
  //     required
  //   }
  // },
  methods: {
    // status(validation) {
    //   return {
    //     error: validation.$error,
    //     dirty: validation.$dirty
    //   };
    // },
    changeFamilyName(e) {
      const val = e.target.value;
      this.familyName = val
      this.$emit("handle-change-familyname", this.familyName);
    },
    changeFirstName(e) {
      const val = e.target.value;
      this.firstName = val
      this.$emit("handle-change-fairstname", this.firstName);
    }
  }
}
</script>

<style>
.margin-right-10 {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/molecules/InputName.vue